import coffe from "../../assets/images/information/coffee.png";
import danger from "../../assets/images/information/danger.png";
import circle from "../../assets/images/information/percentage-circle.png";

const NutritionInformation = ({
  onClose,
  allergens,
  physical_activity,
  caffeine_percentage,
  sodium_percentage,
}) => {
  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.box}>
        <h2 style={styles.title}>معلومات التغذية</h2>

        <div style={styles.warningBox}>
          <div style={styles.warningBoxDetails}>
            <img src={danger} alt="danger" />
            <p style={styles.warningTitle}>مسببات الحساسية</p>
          </div>
          <p style={styles.warningText}>{allergens}</p>
        </div>

        <hr style={styles.divider} />

        <div style={styles.warningBox}>
          <div style={styles.warningBoxDetails}>
            <img src={danger} alt="danger" />
            <p style={styles.warningTitle}>النشاط البدني</p>
          </div>
          <p style={styles.warningText}>{physical_activity}</p>
        </div>

        <hr style={styles.divider} />

        <div style={styles.warningBoxDetails}>
          <div style={styles.details}>
            <img src={circle} alt="circle" />
            <span>نسبة الصوديوم</span>
            <span>{sodium_percentage}%</span>
          </div>

          <div>|</div>

          <div style={styles.details}>
            <img src={coffe} alt="coffe" />
            <span>محتوي الكافيين</span>
            <span>{caffeine_percentage}%</span>
          </div>
        </div>

        <button style={styles.button} onClick={onClose}>
          حسنًا
        </button>
      </div>
    </div>
  );
};

export default NutritionInformation;

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(38, 38, 38, 0.5)",
    display: "flex",
    flexDirection: "column", 
    justifyContent: "flex-end", 
    alignItems: "center", 
    zIndex: 9999,
  },
  box: {
    backgroundColor: "white",
    padding: "18px 18px 50px 18px",
    borderRadius: "24px 24px 0 0",
    width: "100%",
    border: "1px solid grey",
  },

  title: {
    fontSize: "16px",
    fontWeight: "bold",
    margin: "16px 0",
    textAlign: "center",
  },
  warningBox: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    color: "black",
  },
  warningBoxDetails: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    margin: "0",
  },
  warningTitle: {
    margin: 0,
    fontWeight: "bold",
    fontSize: "15px",
  },
  warningText: {
    margin: 0,
    fontSize: "14px",
  },
  details: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  divider: {
    border: "none",
    borderBottom: "1px solid black",
    margin: "12px 0",
  },
  button: {
    marginTop: "20px",
    width: "100%",
    padding: "12px",
    backgroundColor: "#4faf5a",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    cursor: "pointer",
  },
};
